import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  paper: {
    width: '100%',
    height: '100%',
    [theme.breakpoints.up('mobile')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: [0, theme.spacing(2)],
      maxWidth: 800,
      minWidth: 800,
      marginTop: theme.spacing(4),
      height: 'unset',
    },
  },
  progressBar: {
    width: '100%',
    padding: [theme.spacing(7), 0],
  },
  divider: {
    width: '100%',
    borderBottom: [1, 'solid', theme.palette.colors.border],
    marginTop: theme.spacing(7),
  },
  survey: {
    width: '100%',
    height: '100%',
    [theme.breakpoints.up('mobile')]: {
      boxShadow: 'rgb(0 0 0 / 12%) 0px 6px 16px',
      height: 'unset',
      border: [1, 'solid', theme.palette.colors.border],
      padding: theme.spacing(4),
      marginBottom: theme.spacing(4),
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/NonAuthSurveyPage/useStyles.js